import { Injectable } from '@angular/core';

export interface OffsiteEligibilityResult {
  employee: any;
  eligible: boolean;
  reason: string;
  hasEmployeeOffsiteAccess: boolean;
}

@Injectable({ providedIn: 'root' })
export class OffsiteEligibilityService {
  getEligibilityResult(empData: any): OffsiteEligibilityResult {
    const employee = empData?.data || empData;

    if (!employee) {
      return {
        employee: null,
        eligible: false,
        reason: 'No employee data available',
        hasEmployeeOffsiteAccess: false
      };
    }

    const hasEmployeeOffsiteAccess = employee.offsite === true;
    return {
      employee,
      hasEmployeeOffsiteAccess,
      eligible: hasEmployeeOffsiteAccess,
      reason: hasEmployeeOffsiteAccess
        ? 'Employee offsite flag is true'
        : 'Employee offsite flag is not true'
    };
  }

  isEligible(empData: any): boolean {
    return this.getEligibilityResult(empData).eligible;
  }

  getEmployeeEmail(empData: any): string {
    const employee = empData?.data || empData;
    return employee?.email || '';
  }

  isAllowlisted(empData: any): boolean {
    return this.getEligibilityResult(empData).hasEmployeeOffsiteAccess;
  }
}
